import { useMemo } from 'react';
import * as Yup from 'yup';
import { RequiredStringSchema } from 'yup/lib/string';
import { i18n_75_characters_maximum } from '@yi/i18n/phrases/i18n_75_characters_maximum';
import { i18n_invalid_email_address } from '@yi/i18n/phrases/i18n_invalid_email_address';
import { i18n_required } from '@yi/i18n/phrases/i18n_required';

// rule is disabled, because othewise we have cycle deps
// TODO: we need to think about moving LocaleProvider to some common module
// eslint-disable-next-line yi/avoid-relative-parent-imports-v2
import { useLocale } from '../../components/LocaleProvider';

const MAX_EMAIL_LENGTH = 75;

export function useEmailSchema(): RequiredStringSchema<string> {
  const { locale } = useLocale();

  return useMemo(
    () =>
      // Yup doesn't provide generic to handle chainings with required
      // Possible it'll be fixed in v1
      Yup.string()
        .email(i18n_invalid_email_address(locale))
        // NOTE: the message length limit is set in the database. Do not remove the length validation before changes are made on the backend
        .max(MAX_EMAIL_LENGTH, i18n_75_characters_maximum(locale))
        .required(i18n_required(locale)) as RequiredStringSchema<string>,
    [locale],
  );
}
